import React from "react";
import ProfilePages from "../../Components/DashBoard/profilepage";
function ProfilePage() {
  return <ProfilePages />;
}

export default ProfilePage;
